import React from 'react';
import {SocialMedia} from '../components/index';


const AppWrap = (Components, idName, className) => function HOC() {
    return (
        <div id={idName} className={`app__container ${className}`}>
            <SocialMedia/>

            <div className="app_wrapper app__flex">
                <Components/>
            </div>
        </div>
    )
}

export default AppWrap;

